import { createAsyncThunk } from '@reduxjs/toolkit';
import getEmployerFilingsOverview from 'scenes/EmployerFilings/store/services/getEmployerFilingsOverview.service';

// The API returns only the employer's projects where the user's
// filings_manage resolves true, each with its filings.
export const loadEmployerFilingsOverview = createAsyncThunk(
  'employerFilings/loadEmployerFilingsOverview',
  async (employerProjectId) => {
    const response = await getEmployerFilingsOverview(employerProjectId);

    return {
      employerProjectId,
      projects: response?.projects || [],
    };
  }
);
